/**
 * 连续点击被识别为同一次多击操作的最大间隔，单位为毫秒。
 */
export const MULTI_CLICK_GAP_MS = 350;

/**
 * 需要立即显示光标的方向键集合。
 */
export const CARET_REVEAL_KEYS = new Set(['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown']);

/**
 * 进入文字编辑前预热的字符集，避免首次输入常见字符时出现字体缺字或闪烁。
 */
export const EDITOR_PREWARM_CHARS =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZ' + 'abcdefghijklmnopqrstuvwxyz' + '0123456789' + ' ' + ',.!?' + '，。！？';

/**
 * Text Editor 对外发送的事件名称。
 */
export const Events = {
    /**
     * 当前编辑会话发生变化。
     */
    SessionChange: 'text-editor/session-change',
} as const;
